import type { UILabeledAggregation } from '../services/SiteReportingService/types';

export interface DeliveryPerformanceReportSummaryDetail {
  ['0']: number;
  ['1']: number;
  ['2']: number;
  ['3']: number;
  ['4-5']: number;
  ['6-7']: number;
  ['8']: number;
  total: number;
}
export interface DeliveryPerformanceReportLineData extends DeliveryPerformanceReportSummaryDetail {
  segmentStartTime: number;
}

export const deliveryPerfomanceSummary = (data: UILabeledAggregation[]) => {
  const grouped = data.reduce<any>(
    (accum, current) => {
      const days = parseInt(current.label, 10);
      if (days < 4) {
        accum[String(days)] += current.value;
      } else if (days < 5) {
        accum['4-5'] += current.value;
      } else if (days < 8) {
        accum['6-7'] += current.value;
      } else {
        accum['8'] += current.value;
      }
      accum.total += current.value;
      return accum;
    },
    { '0': 0, '1': 0, '2': 0, '3': 0, '4-5': 0, '6-7': 0, '8': 0, total: 0 },
  );
  return grouped;
};

export const deliveryPerfomanceLineData = (data: UILabeledAggregation[]) => {
  const groupedByStartTime = data.reduce((accum: Record<string, any>, current) => {
    // aggregate by the number of days each bucket missed their SLA, normalize faster than expected results to 0
    const days = parseInt(current.label, 10);

    if (!accum[current.segmentStartTime]) {
      accum[current.segmentStartTime] = {
        '0': 0,
        '1': 0,
        '2': 0,
        '3': 0,
        '4-5': 0,
        '6-7': 0,
        '8': 0,
        total: 0,
      };
    }
    if (days < 4) {
      accum[current.segmentStartTime][String(days)] += current.value;
    } else if (days < 5) {
      accum[current.segmentStartTime]['4-5'] += current.value;
    } else if (days < 8) {
      accum[current.segmentStartTime]['6-7'] += current.value;
    } else {
      accum[current.segmentStartTime]['8'] += current.value;
    }
    accum[current.segmentStartTime].total += current.value;
    return accum;
  }, {});
  const lineData: any[] = Object.keys(groupedByStartTime).map((key) => {
    const roundedPercentage = (amount: number, total: number) => {
      return Math.round(((amount * 100) / total + Number.EPSILON) * 100) / 100;
    };
    return Object.keys(groupedByStartTime[key]).reduce(
      (accum: any, innerKey: any) => {
        accum[innerKey] = roundedPercentage(groupedByStartTime[key][innerKey], groupedByStartTime[key].total);
        return accum;
      },
      { segmentStartTime: new Date(key).getTime() },
    );
  });
  return lineData;
};
